import React from "react";
import _ from "lodash";
import __ from "src/utils/Translations";
import { isDevMode } from "src/config/env";
import { isFlagActive } from "src/utils/hooks/useFeatureFlag/useFeatureFlags";
import { godPermission } from "./permissions";
import ForbiddenPage from "./SecurityComponents/ForbiddenPage";

const isDev = isDevMode();
export const filterNavItemsByAlc = (
  menu,
  userInfo,
  companyData,
  /**
   * Temporary prop added to control visibility of menu items (e.g., Positions, Locations)
   * based on company structure availability.
   *
   * TODO: To be refactored once proper Role-Based Security permission for "created structure" is available.
   */
  hasStructure
) => {
  const permissions = userInfo.getPermissions();

  const {
    functionalities = [],
    ahrMyBenefitActiveUrl = "",
    ombMyBenefitActiveUrl = "",
    ahrPayrollModuleUrl = "",
  } = companyData || {};
  return menu
    .map((item) => {
      if (item.dev && !isDev) {
        return null;
      }
      if (item.aclKey) {
        if (
          typeof item.aclKey === "string" &&
          !permissions.includes(item.aclKey) &&
          !permissions.includes(godPermission)
        ) {
          return null;
        }
        if (
          Array.isArray(item.aclKey) &&
          !_.intersection(permissions, item.aclKey).length &&
          !permissions.includes(godPermission)
        ) {
          return null;
        }
      }

      if (item.featureFlag) {
        const hasFeatureFlagEnabled = window.featureFlags
          ? isFlagActive(window.featureFlags, item.featureFlag)
          : false;

        const enabledInGrowthBook = window.growthbookInstance
          ? window.growthbookInstance.isOn(item.featureFlag)
          : false;

        if (!hasFeatureFlagEnabled && !enabledInGrowthBook) {
          return null;
        }
      }

      if (item.isStructureRequired) {
        if (!hasStructure) {
          return null;
        }
      }

      // Nav item is enabled on one functionality - item.functionality is a string
      // Nav item is enabled on multiple functionalities - item.functionalities is an array of strings
      if (
        (companyData &&
          item.functionality &&
          !functionalities.includes(item.functionality)) ||
        (companyData &&
          item.functionalities?.length &&
          !_.intersection(functionalities, item.functionalities).length)
      ) {
        // if companyData is not defined, we can't filter by functionality
        return null;
      }
      const updatedItem = { ...item };
      if (
        updatedItem.href &&
        updatedItem.href.includes("{MyBenefitActiveUrl}")
      ) {
        updatedItem.href = userInfo.isAhr()
          ? ahrMyBenefitActiveUrl
          : ombMyBenefitActiveUrl;
        if (!updatedItem.href) {
          return null;
        }
      }

      if (updatedItem.href && updatedItem.href.includes("{PayrollModuleUrl}")) {
        updatedItem.href = userInfo.isAhr() ? ahrPayrollModuleUrl : "";
        if (!updatedItem.href) {
          return null;
        }
      }

      if (updatedItem.href && updatedItem.href.includes("{mbDashboardUrl}")) {
        updatedItem.href = window.mbDashboardUrl;
        if (!updatedItem.href) {
          return null;
        }
      }

      if (item.content) {
        updatedItem.content = filterNavItemsByAlc(
          item.content,
          userInfo,
          companyData,
          hasStructure
        );
        if (updatedItem.content.length === 0) {
          return null;
        }
      }
      return updatedItem;
    })
    .filter(Boolean);
};

export const filterTabsByAcl = (tabsConfig, userInfo) => {
  const permissions = userInfo.getPermissions();
  return tabsConfig
    .map((item) => {
      // Enable passing an array of keys to control which menu items are displayed (previously only a single string was supported).
      if (
        item.aclKey &&
        !(
          permissions.includes(godPermission) ||
          (Array.isArray(item.aclKey)
            ? item.aclKey.some((key) => permissions.includes(key))
            : permissions.includes(item.aclKey))
        )
      ) {
        return {
          ...item,
          component: <ForbiddenPage permission={item.aclKey} />,
          disabled: true,
          tabClassName: "not-allowed",
          tabTitle: __("Nie masz uprawnień ({0})", [item.aclKey]),
        };
      }
      return item;
    })
    .filter(Boolean);
};

export const hasAccessTo = (userInfo, aclKey) => {
  const permissions = userInfo.getPermissions();
  return Boolean(
    permissions.includes(godPermission) || permissions.includes(aclKey)
  );
};
